// material-ui
import { Card, CardContent, Grid } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import { borderRadius } from '@mui/system';

// ==============================|| SKELETON - EARNING CARD ||============================== //

const HistoryList = () => (
    <Card>
        <CardContent sx={{ padding: 1 }}>
            <Grid container direction="row">
                <Grid item sx={{ marginRight: 1 }}>
                    <Skeleton variant="rectangular" height={50} width={50} sx={{ borderRadius: 50 }} />
                </Grid>
                <Grid container sx={{ width: 'calc( 100% - 65px )' }} justifyContent="space-between">
                    <Grid item sx={{ width: '50%' }} direction="column">
                        <Skeleton variant="rectangular" height={20} width={'50%'} sx={{ marginBottom: 1 }} />
                        <Skeleton variant="rectangular" height={20} width={'100%'} />
                    </Grid>
                    <Grid item sx={{ width: '30%' }} direction="column">
                        <Skeleton variant="rectangular" height={17} width={'100%'} sx={{ marginBottom: 1 }} />
                        <Skeleton variant="rectangular" height={17} width={'70%'} sx={{ marginLeft: 'auto' }} />
                    </Grid>
                </Grid>
            </Grid>
        </CardContent>
    </Card>
);

export default HistoryList;
